// extracted by mini-css-extract-plugin
module.exports = {"card":"LandingCard_card__hHOTr","text":"LandingCard_text__CFgQ2"};